"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UAE_PASS_UPSERT_USER_DATA = exports.UAE_PASS_LOGIN_ACCESSCODE = exports.GET_UAE_PASS_REDIRECT_URL = exports.GET_UAE_PASS_REDIRECT_CONFIG = exports.GET_UAE_PASS_LOGOUT_REDIRECT_URL = void 0;
const GET_UAE_PASS_REDIRECT_URL = exports.GET_UAE_PASS_REDIRECT_URL = 'getUaePassRedirectUrl';
const UAE_PASS_UPSERT_USER_DATA = exports.UAE_PASS_UPSERT_USER_DATA = 'uaePassUpsertUserData';
const UAE_PASS_LOGIN_ACCESSCODE = exports.UAE_PASS_LOGIN_ACCESSCODE = 'uaePassLoginAccessCode';
const GET_UAE_PASS_REDIRECT_CONFIG = exports.GET_UAE_PASS_REDIRECT_CONFIG = 'getUaePassRedirectConfig';
const GET_UAE_PASS_LOGOUT_REDIRECT_URL = exports.GET_UAE_PASS_LOGOUT_REDIRECT_URL = 'getUaePassLogoutRedirectUrl';